import React, {Component} from 'react';
import Ionicon from "react-ionicons";

class GenericModal extends Component {

    renderMessage(header, message, onClose) {
        return (
            <div>
                <h3 className="h3">{ header }</h3>
                <p className="p-tag">{ message }</p>
                <ul className="buttons-left">
                    <li>
                        <button type="button" className="btn btn-primary" onClick={ (e) => onClose(e) }>
                            <span className="label">Close</span>
                        </button>
                    </li>
                </ul>
            </div>
        )
    }

    render() {

        const {isOpen, onClose, header, message} = this.props;

        if (isOpen === false)
            return null;

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={ (e) => onClose(e) }><Ionicon
                            icon="ion-close"/></button>
                        { this.renderMessage(header, message, onClose) }
                    </div>
                </div>
            </div>
        )
    }
}

export default GenericModal;


// WEBPACK FOOTER //
// src/client/components/common/elements/GenericModal.js